import { graphql } from "../gql";

export const requestClaimScanEmailMutation = graphql(`
  mutation requestClaimScanEmail($input: ClaimScanEmailRequest!) {
    requestClaimScanEmail(input: $input) {
      __typename
      id
      ... on WebScan {
        claimed
      }
    }
  }
`);
